import * as React from 'react';
import styled from 'styled-components';
import { Size } from '../types';

type TabsProps = {
  children?: any;
  size: Size;
};

const getHeight = (size: Size) => {
  switch (size) {
    case Size.Small:
      return '48px';
    case Size.Medium:
      return '56px';
    case Size.Large:
      return '64px';
    default:
      return '48px';
  }
};

const getFontSize = (size: Size) => {
  switch (size) {
    case Size.Small:
      return '16px';
    case Size.Medium:
      return '18px';
    case Size.Large:
      return '20px';
    default:
      return '20px';
  }
};

const getTopMargin = (size: Size) => {
  switch (size) {
    case Size.Small:
      return '6px';
    case Size.Medium:
      return '10px';
    case Size.Large:
      return '12px';
    default:
      return '12px';
  }
};

const getBottomMargin = (size: Size) => {
  switch (size) {
    case Size.Small:
      return '2px';
    case Size.Medium:
      return '3px';
    case Size.Large:
      return '4px';
    default:
      return '4px';
  }
};

const Nav = styled.nav<{$size: Size}>`
  display: flex;
  flex-direction: column;

  a {
    height: ${(props) => getHeight(props.$size)};
  }

  a > div:last-of-type {
    font-size: ${(props) => getFontSize(props.$size)};
    margin: 0 0 8px 16px;
  }
  a > div:first-child {
    font-size: ${(props) => getFontSize(props.$size)};
    margin: ${(props) => getTopMargin(props.$size)} 0 ${(props) => getBottomMargin(props.$size)} 16px;
  }
  a > div:only-of-type {
    font-size: ${(props) => getFontSize(props.$size)};
    margin: auto 0 auto 16px;
  }

  @media print {
    display: none;
  }
`;

const Tabs: React.FunctionComponent<TabsProps> = ({ children, size }) => (
  <Nav role="tablist" $size={size}>
    {children}
  </Nav>
);

export default Tabs;
